import { createAction } from '@wix/communities-blog-client-common';

export const CATEGORY_LABEL_CLICKED = 'categoryLabel/CLICKED';

export const categoryLabelClicked = createAction(CATEGORY_LABEL_CLICKED);
